/**
 * =============================================================================
 * WlBillingTab
 *
 * Conteúdo da aba "Cobrança" do painel WL Financeiro.
 * Compõe:
 *   - WlBillingKpiCards               (4 KPIs principais)
 *   - WlBillingTrendGrid              (4 sparklines 12 meses)
 *   - WlBillingAgingCard (2/3)        + WlBillingByPaymentMethodCard (1/3)
 *
 * Uma única chamada à RPC `wl_get_billing_kpis` alimenta todos os blocos.
 *
 * @version 1.1.0
 * RELEASE:
 *   2026-07-22 v1.0.0 - Versão inicial.
 *   2026-07-22 v1.1.0 - Adiciona donut "Cobranças por meio de pagamento" ao
 *                       lado do card "Faturas pendentes" (grid 2/3 + 1/3).
 * =============================================================================
 */
import { useWlBillingKpis } from '@/hooks/wl/useWlBillingKpis';
import { WlBillingKpiCards } from './WlBillingKpiCards';
import { WlBillingTrendGrid } from './WlBillingTrendGrid';
import { WlBillingAgingCard } from './WlBillingAgingCard';
import { WlBillingByPaymentMethodCard } from './WlBillingByPaymentMethodCard';

export function WlBillingTab() {
  const { data, isLoading, error } = useWlBillingKpis(null, 'America/Sao_Paulo', 12);

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive">
        Erro ao carregar KPIs de cobrança: {(error as Error).message}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <WlBillingKpiCards data={data} isLoading={isLoading} />
      <WlBillingTrendGrid data={data} isLoading={isLoading} />

      {/* Linha final: aging (2/3) + meios de pagamento (1/3) em desktop. */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <WlBillingAgingCard data={data} isLoading={isLoading} />
        </div>
        <div className="lg:col-span-1">
          <WlBillingByPaymentMethodCard data={data} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
}

